import { makeStyles, Theme } from '@material-ui/core';
import { type KeyboardEvent as ReactKeyboardEvent, type MouseEvent as ReactMouseEvent, type ReactNode } from 'react';

interface LinkButtonProps {
  url: string;
  children: ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
  linkButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    color: 'inherit',
    textDecoration: 'underline',
    cursor: 'pointer',
    font: 'inherit',
    transition: theme.transitions.create(['color', 'opacity'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      opacity: 0.8,
    },
    '&:focus': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: '2px',
    },
  },
}));

export const LinkButton = ({ url, children }: LinkButtonProps) => {
  const classes = useStyles();

  const openInNewTab = (event: ReactMouseEvent | ReactKeyboardEvent) => {
    event.preventDefault();

    if (
      event.type === 'keydown' &&
      (event as ReactKeyboardEvent).key !== 'Enter' &&
      (event as ReactKeyboardEvent).key !== ' '
    ) {
      return;
    }

    const targetUrl = url;
    window.open(targetUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button type="button" onClick={openInNewTab} onKeyDown={openInNewTab} className={classes.linkButton}>
      {children}
    </button>
  );
};
